import script from "./subjectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./subjectPage.vue?vue&type=script&setup=true&lang=js"

import "./subjectPage.vue?vue&type=style&index=0&id=be88ab24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be88ab24"]])

export default __exports__